<template>
  <div id="BARRING_FACTORING_HISTORY_SHOW" class="offset-bottom-6">
    <div class="container-fixed">
      <p class="offset-top-2" v-html="$t(addOptionalSuffix(isProfileTypeCategories ? 'barring.editInfotextCategory' : 'barring.editInfotext', crm))"></p>
    </div>

    <VSelection
      :items="editItems"
      :type="isProfileTypeCategories ? 'categories' : 'partners'"
      :hide-filter-type="isProfileTypeCategories"
      read-only
      @open:exceptions="onOpenExceptions"
      @open:details="onOpenDetails"
    />

    <!-- save buttons -->
    <div class="container-fixed">
      <div class="row offset-top-2 offset-bottom-2">
        <div class="col-l-8 col-s-12 offset-bottom-1">
          <p class="offset-left-1 offset-right-2" style="margin-top: -12px" v-html="$t('barring.saveInfotext')"></p>
        </div>
        <div class="col-l-4 col-s-12">
          <section class="pull-right offset-right-1 button-bar">
            <VButton class="btn-default" :to="{ name: BARRING_FACTORING_HISTORY }" label="barring.backToHistory" />
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VButton from '@/components/Button';
import TitleMixin from '@/mixins/title';
import VSelection from '@/components/Barring/PartnerSelection';
import { BARRING_FACTORING_HISTORY, BARRING_FACTORING_HISTORY_SHOW_EXCEPTIONS } from '@route-types';
import { addOptionalSuffix } from '@/utils/i18n';

export default {
  name: 'BarringFactoringHistoryShow',

  components: {
    VButton,
    VSelection,
  },

  mixins: [TitleMixin],

  props: {
    item: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      BARRING_FACTORING_HISTORY,
      addOptionalSuffix,
      modalInfo: null,
    };
  },

  computed: {
    ...mapState('contract', ['contractHash']),

    ...mapState('system', ['crm']),

    ...mapState('barring', ['editItems', 'isProfileTypeCategories']),
  },

  methods: {
    onOpenDetails(item) {
      this.modalInfo = item;
    },

    onOpenExceptions(item) {
      this.$router.push({ name: BARRING_FACTORING_HISTORY_SHOW_EXCEPTIONS, params: { id: item.id } });
    },
  },
};
</script>
